import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-flex-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.items,
    id: "models-table",
    class: "p-datatable-sm kn-table",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
    filterDisplay: "menu",
    dataKey: "name",
    responsiveLayout: "stack",
    breakpoint: "960px"
  }, {
    empty: _withCtx(() => [
      _createVNode(_component_Message, {
        class: "p-m-2",
        severity: "info",
        closable: false,
        style: _ctx.workspaceModelsTableDescriptor.styles.message
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workspaceModelsTableDescriptor.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          field: col.field,
          header: _ctx.$t(col.header),
          key: col.field,
          sortable: true
        }, {
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              class: "p-column-filter"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1032, ["field", "header"]))
      }), 128)),
      _createVNode(_component_Column, {
        style: _ctx.workspaceModelsTableDescriptor.iconColumn.style
      }, {
        body: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_1, [
            (slotProps.data.type === 'federatedDataset')
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode(_component_Button, {
                    icon: "fas fa-ellipsis-v",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.toggle($event, slotProps.data))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Menu, {
                    ref: "menu",
                    model: _ctx.menuItems,
                    popup: true
                  }, null, 8, ["model"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_Button, {
              icon: "fas fa-info-circle",
              class: "p-button-link",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('selected', slotProps.data)), ["stop"]),
              "data-test": 'info-button-' + slotProps.data.name
            }, null, 8, ["onClick", "data-test"]), [
              [
                _directive_tooltip,
                _ctx.$t('workspace.myModels.showInfo'),
                void 0,
                { left: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              icon: "fas fa-search",
              class: "p-button-link",
              onClick: _withModifiers(($event: any) => (_ctx.openDatasetInQBE(slotProps.data)), ["stop"])
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('workspace.myModels.openInQBE'),
                void 0,
                { left: true }
              ]
            ])
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["value", "filters"]))
}